(function () {
  const builder =
    document.getElementById('mhx-pump-builder');
  if (!builder) return;
  if (builder.dataset.initialized === 'true') return;
  builder.dataset.initialized = 'true';
  /* =====================================================
     HELPERS
     ===================================================== */
  const number =
    value => Number(value || 0);
  /* =====================================================
     PRODUCT DATA
     ===================================================== */
  const products = {
    pump: {
      id: number(builder.dataset.pumpId),
      price: number(builder.dataset.pumpPrice),
      available:
        builder.dataset.pumpAvailable === 'true'
    },
    full: {
      id: number(builder.dataset.fullId),
      price: number(builder.dataset.fullPrice),
      available:
        builder.dataset.fullAvailable === 'true'
    },
    expansion: {
      id: number(builder.dataset.expansionId),
      price: number(builder.dataset.expansionPrice),
      available:
        builder.dataset.expansionAvailable === 'true'
    },
    training: {
      id: number(builder.dataset.trainingId),
      price: number(builder.dataset.trainingPrice),
      available:
        builder.dataset.trainingAvailable === 'true'
    },
    recovery: {
      id: number(builder.dataset.recoveryId),
      price: number(builder.dataset.recoveryPrice),
      available:
        builder.dataset.recoveryAvailable === 'true'
    }
  };
  const currency =
    builder.dataset.currency ||
    (
      window.Shopify &&
      window.Shopify.currency &&
      window.Shopify.currency.active
        ? window.Shopify.currency.active
        : 'EUR'
    );
  /* =====================================================
     MAIN ELEMENTS
     ===================================================== */
  const mainRadios =
    builder.querySelectorAll(
      'input[name="mhx-pump-kit"]'
    );
  const mainCards =
    builder.querySelectorAll(
      '[data-kit-card]'
    );
  const mainCheckboxes =
    builder.querySelectorAll(
      '.mhx-program-checkbox'
    );
  const customCardPrice =
    builder.querySelector(
      '#mhx-custom-card-price'
    );
  const customTotal =
    builder.querySelector(
      '#mhx-custom-total'
    );
  const addButton =
    builder.querySelector(
      '#mhx-pump-add'
    );
  const mainMessage =
    builder.querySelector(
      '#mhx-kit-message'
    );
  /* =====================================================
     STICKY ELEMENTS
     ===================================================== */
  const sticky =
    document.getElementById(
      'mhx-pump-sticky'
    );
  const stickyPanel =
    document.getElementById(
      'mhx-sticky-panel'
    );
  const stickyToggle =
    document.getElementById(
      'mhx-sticky-toggle'
    );
  const stickyButton =
    document.getElementById(
      'mhx-sticky-button'
    );
  /* =====================================================
     ORIGINAL CTA CONTENT
     Liquid/HTML is the source of truth for the default CTA.
     ===================================================== */
  const mainButtonDefaultHTML =
    addButton
      ? addButton.innerHTML
      : '';
  const stickyButtonDefaultHTML =
    stickyButton
      ? stickyButton.innerHTML
      : '';
  const stickySummaryLabel =
    document.getElementById(
      'mhx-sticky-summary-label'
    );
  const stickySummaryDetail =
    document.getElementById(
      'mhx-sticky-summary-detail'
    );
  const stickyPrice =
    document.getElementById(
      'mhx-sticky-price'
    );
  const stickyCustomPrice =
    document.getElementById(
      'mhx-sticky-custom-price'
    );
  const stickyOptions =
    sticky
      ? sticky.querySelectorAll(
          '[data-sticky-kit-card]'
        )
      : [];
  const stickyRadios =
    sticky
      ? sticky.querySelectorAll(
          'input[name="mhx-sticky-kit"]'
        )
      : [];
  const stickyCustomArea =
    document.getElementById(
      'mhx-sticky-custom-area'
    );
  const stickyModeCheckboxes =
    sticky
      ? sticky.querySelectorAll(
          '.mhx-sticky-program-checkbox'
        )
      : [];
  /* =====================================================
     STATE
     ===================================================== */
  let state = {
    type: 'pump',
    items: [
      {
        id: products.pump.id,
        quantity: 1
      }
    ],
    total:
      products.pump.price
  };
  let stickyExpanded =
    false;
  /* =====================================================
     MONEY
     ===================================================== */
  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat(
        document.documentElement.lang || 'en',
        {
          style: 'currency',
          currency: currency
        }
      ).format(
        cents / 100
      );
    }
    catch (error) {
      return (
        (cents / 100).toFixed(2) +
        ' ' +
        currency
      );
    }
  }
  /* =====================================================
     BUNDLE ID
     ===================================================== */
  function createBundleId() {
    return (
      'pump_' +
      Date.now().toString(36) +
      '_' +
      Math.random()
        .toString(36)
        .slice(2, 8)
    );
  }
  /* =====================================================
     MAIN CHECKBOX BY PROGRAM
     ===================================================== */
  function getMainCheckbox(program) {
    return builder.querySelector(
      '.mhx-program-checkbox[data-program="' +
      program +
      '"]'
    );
  }
  /* =====================================================
     CLEAR CUSTOM MODES
     ===================================================== */
  function clearCustomModes() {
    mainCheckboxes.forEach(
      function (checkbox) {
        checkbox.checked =
          false;
      }
    );
  }
  /* =====================================================
     CUSTOM PRICE
     ===================================================== */
  function getCustomPrice() {
    let total =
      products.pump.price;
    mainCheckboxes.forEach(
      function (checkbox) {
        if (
          checkbox.checked &&
          !checkbox.disabled
        ) {
          total +=
            number(
              checkbox.dataset.price
            );
        }
      }
    );
    return total;
  }
  /* =====================================================
     MODE COUNT
     ===================================================== */
  function getSelectedModeCount() {
    let count =
      0;
    mainCheckboxes.forEach(
      function (checkbox) {
        if (
          checkbox.checked &&
          !checkbox.disabled
        ) {
          count++;
        }
      }
    );
    return count;
  }
  /* =====================================================
     CTA STATES
     Default CTA is always restored from the Liquid/HTML.
     ===================================================== */
  function setMainButtonState(status) {
    if (!addButton) return;
    if (status === 'sold-out') {
      addButton.innerHTML =
        '<span class="mhx-kit-atc__main">SOLD OUT</span>';
      return;
    }
    if (status === 'adding') {
      addButton.innerHTML =
        '<span class="mhx-kit-atc__main">ADDING...</span>';
      return;
    }
    if (status === 'added') {
      addButton.innerHTML =
        '<span class="mhx-kit-atc__main">ADDED ✓</span>';
      return;
    }
    addButton.innerHTML =
      mainButtonDefaultHTML;
  }
  function setStickyButtonState(status) {
    if (!stickyButton) return;
    if (status === 'sold-out') {
      stickyButton.textContent =
        'SOLD OUT';
      return;
    }
    if (status === 'adding') {
      stickyButton.textContent =
        'ADDING...';
      return;
    }
    if (status === 'added') {
      stickyButton.textContent =
        'ADDED ✓';
      return;
    }
    stickyButton.innerHTML =
      stickyButtonDefaultHTML;
  }
  /* =====================================================
     STICKY OPEN / CLOSE
     ===================================================== */
  function setStickyExpanded(isOpen) {
    if (!sticky) return;
    stickyExpanded =
      Boolean(isOpen);
    sticky.classList.toggle(
      'is-expanded',
      stickyExpanded
    );
    if (stickyPanel) {
      stickyPanel.hidden =
        !stickyExpanded;
    }
    if (stickyToggle) {
      stickyToggle.setAttribute(
        'aria-expanded',
        stickyExpanded
          ? 'true'
          : 'false'
      );
    }
  }
  /* =====================================================
     SELECT MAIN KIT
     ===================================================== */
  function selectMainKit(type) {
    if (
      type !== 'custom'
    ) {
      clearCustomModes();
    }
    const radio =
      builder.querySelector(
        'input[name="mhx-pump-kit"][value="' +
        type +
        '"]'
      );
    if (!radio) return;
    radio.checked =
      true;
    calculateState();
  }
  /* =====================================================
     MAIN CARD CLICKS
     ===================================================== */
  mainCards.forEach(
    function (card) {
      const main =
        card.querySelector(
          '.mhx-kit-main'
        );
      if (!main) return;
      main.addEventListener(
        'click',
        function (event) {
          if (
            event.target.closest(
              'input'
            )
          ) {
            return;
          }
          selectMainKit(
            card.dataset.kitCard
          );
        }
      );
    }
  );
  /* =====================================================
     MAIN RADIO CHANGE
     ===================================================== */
  mainRadios.forEach(
    function (radio) {
      radio.addEventListener(
        'change',
        function () {
          if (
            radio.value !== 'custom'
          ) {
            clearCustomModes();
          }
          calculateState();
        }
      );
    }
  );
  /* =====================================================
     MAIN MODE CHANGE
     ===================================================== */
  mainCheckboxes.forEach(
    function (checkbox) {
      checkbox.addEventListener(
        'change',
        function () {
          const customRadio =
            builder.querySelector(
              'input[name="mhx-pump-kit"][value="custom"]'
            );
          if (customRadio) {
            customRadio.checked =
              true;
          }
          calculateState();
        }
      );
    }
  );
  /* =====================================================
     CALCULATE STATE
     ===================================================== */
  function calculateState() {
    const selected =
      builder.querySelector(
        'input[name="mhx-pump-kit"]:checked'
      );
    if (!selected) return;
    state.type =
      selected.value;
    /* PUMP LITE */
    if (
      state.type === 'pump'
    ) {
      state.items = [
        {
          id: products.pump.id,
          quantity: 1
        }
      ];
      state.total =
        products.pump.price;
    }
    /* FULL SET */
    else if (
      state.type === 'full'
    ) {
      state.items = [
        {
          id: products.full.id,
          quantity: 1
        }
      ];
      state.total =
        products.full.price;
    }
    /* CREATE YOUR PACK */
    else {
      const items = [
        {
          id: products.pump.id,
          quantity: 1
        }
      ];
      let total =
        products.pump.price;
      mainCheckboxes.forEach(
        function (checkbox) {
          if (
            !checkbox.checked ||
            checkbox.disabled
          ) {
            return;
          }
          const id =
            number(
              checkbox.dataset.id
            );
          const price =
            number(
              checkbox.dataset.price
            );
          if (!id) return;
          items.push({
            id: id,
            quantity: 1
          });
          total +=
            price;
        }
      );
      state.items =
        items;
      state.total =
        total;
    }
    updateUI();
    publishState();
  }
  /* =====================================================
     AVAILABILITY
     ===================================================== */
  function selectionIsAvailable() {
    if (
      state.type === 'pump'
    ) {
      return products.pump.available;
    }
    if (
      state.type === 'full'
    ) {
      return products.full.available;
    }
    if (
      !products.pump.available
    ) {
      return false;
    }
    let available =
      true;
    mainCheckboxes.forEach(
      function (checkbox) {
        if (
          checkbox.checked
        ) {
          const program =
            checkbox.dataset.program;
          if (
            products[program] &&
            !products[program].available
          ) {
            available =
              false;
          }
        }
      }
    );
    return available;
  }
  /* =====================================================
     MAIN UI
     ===================================================== */
  function updateMainUI() {
    mainCards.forEach(
      function (card) {
        card.classList.toggle(
          'is-active',
          card.dataset.kitCard ===
          state.type
        );
      }
    );
    mainCheckboxes.forEach(
      function (checkbox) {
        const option =
          checkbox.closest(
            '.mhx-program-option'
          );
        if (option) {
          option.classList.toggle(
            'is-selected',
            checkbox.checked
          );
        }
      }
    );
    const customPrice =
      getCustomPrice();
    if (customCardPrice) {
      customCardPrice.textContent =
        formatMoney(
          customPrice
        );
    }
    if (customTotal) {
      customTotal.textContent =
        formatMoney(
          customPrice
        );
    }
    const available =
      selectionIsAvailable();
    if (addButton) {
      addButton.disabled =
        !available;
      setMainButtonState(
        available
          ? 'default'
          : 'sold-out'
      );
    }
  }
  /* =====================================================
     STICKY UI
     ===================================================== */
  function updateStickyUI() {
    if (!sticky) return;
    const customPrice =
      getCustomPrice();
    const modeCount =
      getSelectedModeCount();
    /* SUMMARY */
    if (
      state.type === 'pump'
    ) {
      stickySummaryLabel.textContent =
        'PUMP LITE';
      stickySummaryDetail.textContent =
        'Erection Firmness Mode included';
    }
    else if (
      state.type === 'full'
    ) {
      stickySummaryLabel.textContent =
        'FULL SET';
      stickySummaryDetail.textContent =
        'Pump Lite + all 4 guided modes';
    }
    else {
      stickySummaryLabel.textContent =
        'CREATE YOUR PACK';
      stickySummaryDetail.textContent =
        modeCount === 0
          ? 'Pump Lite + choose your modes'
          : (
              modeCount +
              (
                modeCount === 1
                  ? ' extra mode selected'
                  : ' extra modes selected'
              )
            );
    }
    stickyPrice.textContent =
      formatMoney(
        state.total
      );
    if (stickyCustomPrice) {
      stickyCustomPrice.textContent =
        formatMoney(
          customPrice
        );
    }
    /* MAIN OPTIONS */
    stickyRadios.forEach(
      function (radio) {
        radio.checked =
          radio.value ===
          state.type;
      }
    );
    stickyOptions.forEach(
      function (option) {
        option.classList.toggle(
          'is-active',
          option.dataset.stickyKitCard ===
          state.type
        );
      }
    );
    /* CUSTOM AREA */
    if (stickyCustomArea) {
      stickyCustomArea.hidden =
        state.type !==
        'custom';
    }
    /* CUSTOM CHECKBOXES */
    stickyModeCheckboxes.forEach(
      function (stickyCheckbox) {
        const mainCheckbox =
          getMainCheckbox(
            stickyCheckbox.dataset.program
          );
        stickyCheckbox.checked =
          mainCheckbox
            ? mainCheckbox.checked
            : false;
      }
    );
    /* STICKY CTA */
    const available =
      selectionIsAvailable();
    if (stickyButton) {
      stickyButton.disabled =
        !available;
      setStickyButtonState(
        available
          ? 'default'
          : 'sold-out'
      );
    }
  }
  /* =====================================================
     UPDATE ALL
     ===================================================== */
  function updateUI() {
    updateMainUI();
    updateStickyUI();
  }
  /* =====================================================
     GLOBAL STATE
     ===================================================== */
  function publishState() {
    window.MYHIXEL_PUMP_CONFIG = {
      type:
        state.type,
      items:
        JSON.parse(
          JSON.stringify(
            state.items
          )
        ),
      total:
        state.total
    };
    document.dispatchEvent(
      new CustomEvent(
        'myhixel:pump-config-change',
        {
          detail:
            window.MYHIXEL_PUMP_CONFIG
        }
      )
    );
  }
  /* =====================================================
     STICKY ARROW
     ===================================================== */
  if (stickyToggle) {
    stickyToggle.addEventListener(
      'click',
      function (event) {
        event.preventDefault();
        event.stopPropagation();
        setStickyExpanded(
          !stickyExpanded
        );
      }
    );
  }
  /* =====================================================
     STICKY MAIN OPTION CLICKS
     ===================================================== */
  stickyOptions.forEach(
    function (option) {
      option.addEventListener(
        'click',
        function (event) {
          if (
            event.target.closest(
              '.mhx-sticky-custom-area'
            )
          ) {
            return;
          }
          if (
            event.target.closest(
              'input'
            )
          ) {
            return;
          }
          const type =
            option.dataset.stickyKitCard;
          selectMainKit(
            type
          );
          if (
            type === 'custom'
          ) {
            setStickyExpanded(
              true
            );
          }
        }
      );
    }
  );
  /* =====================================================
     STICKY RADIOS
     ===================================================== */
  stickyRadios.forEach(
    function (radio) {
      radio.addEventListener(
        'change',
        function () {
          selectMainKit(
            radio.value
          );
          if (
            radio.value === 'custom'
          ) {
            setStickyExpanded(
              true
            );
          }
        }
      );
    }
  );
  /* =====================================================
     STICKY MODE CHECKBOXES
     ===================================================== */
  stickyModeCheckboxes.forEach(
    function (stickyCheckbox) {
      stickyCheckbox.addEventListener(
        'change',
        function () {
          const program =
            stickyCheckbox.dataset.program;
          const mainCheckbox =
            getMainCheckbox(
              program
            );
          if (
            mainCheckbox &&
            !mainCheckbox.disabled
          ) {
            mainCheckbox.checked =
              stickyCheckbox.checked;
          }
          const customRadio =
            builder.querySelector(
              'input[name="mhx-pump-kit"][value="custom"]'
            );
          if (customRadio) {
            customRadio.checked =
              true;
          }
          calculateState();
          setStickyExpanded(
            true
          );
        }
      );
    }
  );
  /* =====================================================
     STICKY VISIBILITY
     ===================================================== */
  function updateStickyVisibility() {
    if (
      !sticky ||
      !addButton
    ) {
      return;
    }
    const rect =
      addButton.getBoundingClientRect();
    /*
    Sticky appears after the normal
    Add to Cart has been scrolled past.
    */
    const shouldShow =
      rect.bottom < 0;
    sticky.classList.toggle(
      'is-visible',
      shouldShow
    );
    sticky.setAttribute(
      'aria-hidden',
      shouldShow
        ? 'false'
        : 'true'
    );
    if (!shouldShow) {
      setStickyExpanded(
        false
      );
    }
  }
  window.addEventListener(
    'scroll',
    updateStickyVisibility,
    {
      passive: true
    }
  );
  window.addEventListener(
    'resize',
    updateStickyVisibility
  );
  /* =====================================================
     MESSAGES
     ===================================================== */
  function clearMessage() {
    if (!mainMessage) return;
    mainMessage.textContent =
      '';
    mainMessage.className =
      'mhx-kit-message';
  }
  function showError(text) {
    if (!mainMessage) return;
    mainMessage.textContent =
      text;
    mainMessage.className =
      'mhx-kit-message is-error';
  }
  function showSuccess() {
    if (!mainMessage) return;
    mainMessage.textContent =
      'Added to cart.';
    mainMessage.className =
      'mhx-kit-message is-success';
  }
  /* =====================================================
     ADD TO CART
     ===================================================== */
  async function addCurrentSelection(source) {
    clearMessage();
    if (
      !state.items ||
      !state.items.length
    ) {
      showError(
        'Please select a configuration.'
      );
      return;
    }
    if (
      !selectionIsAvailable()
    ) {
      showError(
        'This option is currently unavailable.'
      );
      return;
    }
    if (addButton) {
      addButton.disabled =
        true;
    }
    if (stickyButton) {
      stickyButton.disabled =
        true;
    }
    if (
      source === 'sticky' &&
      stickyButton
    ) {
      setStickyButtonState(
        'adding'
      );
    }
    else if (addButton) {
      setMainButtonState(
        'adding'
      );
    }
    try {
      const bundleId =
        createBundleId();
      let bundleType =
        'pump_lite';
      if (
        state.type === 'full'
      ) {
        bundleType =
          'full_set';
      }
      else if (
        state.type === 'custom'
      ) {
        bundleType =
          'custom_pack';
      }
      const items =
        state.items.map(
          function (item, index) {
            return {
              id:
                item.id,
              quantity:
                item.quantity,
              properties: {
                _pump_bundle_id:
                  bundleId,
                _pump_bundle_type:
                  bundleType,
                _pump_purchase_type:
                  'initial_purchase',
                _pump_bundle_position:
                  String(index + 1)
              }
            };
          }
        );
      const response =
        await fetch(
          window.Shopify.routes.root +
          'cart/add.js',
          {
            method:
              'POST',
            headers: {
              'Content-Type':
                'application/json',
              'Accept':
                'application/json'
            },
            body:
              JSON.stringify({
                items: items
              })
          }
        );
      const responseData =
        await response.json();
      if (!response.ok) {
        throw new Error(
          responseData.description ||
          responseData.message ||
          'Unable to add the selection.'
        );
      }
      setStickyExpanded(
        false
      );
      showSuccess();
      if (addButton) {
        setMainButtonState(
          'added'
        );
      }
      if (stickyButton) {
        setStickyButtonState(
          'added'
        );
      }
      document.dispatchEvent(
        new CustomEvent(
          'myhixel:pump-added',
          {
            bubbles: true,
            detail: {
              config:
                window.MYHIXEL_PUMP_CONFIG,
              response:
                responseData
            }
          }
        )
      );
      [
        'cart:refresh',
        'cart:updated',
        'cart:change'
      ].forEach(
        function (eventName) {
          document.dispatchEvent(
            new CustomEvent(
              eventName,
              {
                bubbles: true
              }
            )
          );
        }
      );
      const cartDrawer =
        document.querySelector(
          'cart-drawer, #CartDrawer, .cart-drawer'
        );
      if (
        cartDrawer &&
        typeof cartDrawer.open ===
        'function'
      ) {
        try {
          cartDrawer.open();
        }
        catch (error) {}
      }
      setTimeout(
        function () {
          updateUI();
        },
        1300
      );
    }
    catch (error) {
      console.error(
        'MYHIXEL Pump Builder:',
        error
      );
      showError(
        error.message ||
        'Something went wrong. Please try again.'
      );
      updateUI();
    }
  }
  /* =====================================================
     MAIN ADD TO CART
     ===================================================== */
  if (addButton) {
    addButton.addEventListener(
      'click',
      function (event) {
        event.preventDefault();
        addCurrentSelection(
          'main'
        );
      }
    );
  }
  /* =====================================================
     STICKY ADD TO CART
     ===================================================== */
  if (stickyButton) {
    stickyButton.addEventListener(
      'click',
      function (event) {
        event.preventDefault();
        addCurrentSelection(
          'sticky'
        );
      }
    );
  }
  /* =====================================================
     NATIVE SHOPIFY PRODUCT FORM
     ===================================================== */
  document.addEventListener(
    'submit',
    function (event) {
      const form =
        event.target.closest(
          'form[action*="/cart/add"]'
        );
      if (!form) return;
      if (
        form.closest(
          '#mhx-pump-builder'
        )
      ) {
        return;
      }
      const idInput =
        form.querySelector(
          '[name="id"]'
        );
      if (!idInput) return;
      const nativeVariantId =
        Number(
          idInput.value
        );
      if (
        nativeVariantId !==
        products.pump.id
      ) {
        return;
      }
      /*
      Normal Pump Lite selected:
      Shopify's native behaviour remains.
      */
      if (
        state.type === 'pump'
      ) {
        return;
      }
      /*
      Full Set or Custom Pack:
      intercept native Pump Lite submission.
      */
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      addCurrentSelection(
        'main'
      );
    },
    true
  );
  /* =====================================================
     INITIALIZE
     ===================================================== */
  calculateState();
  setStickyExpanded(
    false
  );
  updateStickyVisibility();
})();